import { observer } from "mobx-react";
import exchangeInterfaceStore from "../../../stores/ExchangeInterfaceStore";
import { PRESALE_ID, STATUS } from "../../../utils/constants";
import { toast } from "react-toastify";

import Button from "../Button";
import { useClaim } from "../../../utils/hooks/presale-manager/write/useClaim";
import { useEffect } from "react";
import { useWaitForTransactionReceipt } from "wagmi";
import { useClaimableAmount } from "../../../utils/hooks/presale-manager/read/useClaimableAmount";

const ClaimButton = () => {
  const { statuses, setStatus } = exchangeInterfaceStore;
  const claimData = useClaim()!;
  const claim = claimData?.claim!;
  const claimHash = claimData?.claimHash!;
  const refetchClaimableAmount =
    useClaimableAmount(PRESALE_ID)?.refetchClaimableAmount;
  const buttonsClasses = {
    green: `bg-gradient-to-r from-lime-400 via-green-400 to-green-500 hover:shadow-lg hover:shadow-green-500  duration-300 hover:from-green-400 hover:to-green-500`,
    blue: `bg-gradient-to-r from-sky-400 via-blue-400 to-blue-500 hover:shadow-lg hover:shadow-blue-500 duration-300 hover:from-blue-400 hover:to-blue-500`,
    red: `bg-gradient-to-r from-rose-400 via-red-400 to-red-500 hover:shadow-lg hover:shadow-red-500 duration-300 hover:from-red-400 hover:to-red-500`,
  };

  const handler: React.MouseEventHandler<HTMLButtonElement> = async (event) => {
    event.preventDefault();

    if (!statuses.PRESALE_ENDED) return toast.error("Presale still live");
    if (statuses.NOTHING_TO_CLAIM)
      return toast.error("There is nothing to claim");

    setStatus(STATUS.LOADING, true);

    await claim(PRESALE_ID);
    setStatus(STATUS.LOADING, false);

    return;
  };

  const { isSuccess: isClaimConfirmed } = useWaitForTransactionReceipt({
    hash: claimHash,
  });

  useEffect(() => {
    if (isClaimConfirmed && refetchClaimableAmount) {
      toast.success("Tokens claimed succesfully");
      refetchClaimableAmount();
    }
  }, [isClaimConfirmed, refetchClaimableAmount]);

  if (statuses.WALLET_DISCONNECTED) {
    return (
      <Button
        text="Not connected"
        disabled={true}
        classes={buttonsClasses.red}
      />
    );
  }

  if (statuses.WRONG_NETWORK) {
    return (
      <Button
        text="Wrong network"
        disabled={true}
        classes={buttonsClasses.red}
      />
    );
  }

  if (statuses.NOT_ENOUGH_FEES) {
    return (
      <Button
        text="Not enough for fees"
        disabled={true}
        classes={buttonsClasses.red}
      />
    );
  }

  if (!statuses.PRESALE_ENDED) {
    return (
      <Button
        text="Presale is still live"
        disabled={true}
        classes={buttonsClasses.red}
      />
    );
  }

  if (statuses.NOTHING_TO_CLAIM) {
    return (
      <Button
        text="Nothing to claim"
        disabled={true}
        classes={buttonsClasses.red}
      />
    );
  }

  if (statuses.LOADING) {
    return (
      <Button text="Loading..." disabled={true} classes={buttonsClasses.blue} />
    );
  }

  return (
    <Button
      text="Claim now"
      disabled={false}
      classes={buttonsClasses.green}
      onClick={handler}
    />
  );
};

export default observer(ClaimButton);
